import React from 'react';
import InputMask from 'react-input-mask';

import { CircularProgress, IconButton, InputAdornment, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const CustomMaskField = ({
  field,
  form,
  mask,
  loading,
  onClickButton,
  readOnly = false,
  label,
  disabled = false,
  ...other
}) => {
  const handleClickButton = () => {
    if (onClickButton) {
      onClickButton();
    }
  };

  const LoadingAdornment = () => {
    return (
      <InputAdornment position="end">
        <CircularProgress size={16} />
      </InputAdornment>
    );
  };

  const SearchAdornment = () => {
    if (!onClickButton) return <></>;
    return (
      <InputAdornment position="end">
        <IconButton disabled={disabled} onClick={handleClickButton}>
          <SearchIcon />
        </IconButton>
      </InputAdornment>
    );
  };
  return (
    <InputMask mask={mask} disabled={disabled} {...field} {...other}>
      {props => {
        const childProps = {
          ...props,
          ...field,
        };
        if (childProps.onBlur) delete childProps.onBlur;
        if (childProps.onChange) delete childProps.onChange;
        if (childProps.value) delete childProps.value;
        return (
          <TextField
            error={form && form.errors[field.name] && form.touched[field.name]}
            helperText={form && form.touched[field.name] && form.errors[field.name]}
            {...childProps}
            {...other}
            variant={other.variant || 'filled'}
            fullWidth
            disabled={disabled}
            InputLabelProps={{ shrink: true }}
            name={field ? field.name : props.name}
            InputProps={
              loading
                ? {
                    endAdornment: <LoadingAdornment />,
                  }
                : {
                    endAdornment: <SearchAdornment />,
                  }
            }
            inputProps={{
              readOnly: readOnly,
            }}
            label={label}
          />
        );
      }}
    </InputMask>
  );
};

export default CustomMaskField;
